import {
    buildSchema,
} from "@camberi/firecms";

const courseSchema = buildSchema({
    name: "Courses",
    properties: {
        title: {
            dataType: "string",
            title: "Title",
            validation: {
                required: true,
                requiredMessage: "Course name is required.",
            }
        },
        description: {
            dataType: "string",
            title: "Description",
            validation: {
                required: true,
            },
            config: {
                multiline: true,
            }
        },
        theme: {
            dataType: "string",
            title: "Theme",
            validation: {
                required: true,
                requiredMessage: "Choose at least one theme."
            },
            config: {
                enumValues: {
                    dark: "Dark",
                    light: "Light"
                }
            }
        },
        order_by: {

            dataType: "string",
            title: "Order Session By",
            validation: {
                required: true,
                requiredMessage: "Choose at least one order by."
            },
            config: {
                enumValues: {
                    title: "Title",
                    created_at: "Created Date Time",
                }
            }

        },
        tags: {
            dataType: "array",
            title: "Tags",
            // validation: {
            //     required: true
            // },
            of: {
                dataType: "string",
                config: {
                    enumValues:
                    {
                        smile: "Smile",
                        happy: "Happy",
                        sad: "Sad",
                        love: "Love",
                        anxious: "Anxious"
                    }
                }
            }
        },
        type: {
            dataType: "string",
            title: "Type",
            // validation: {
            //     required: true
            // },
            config: {
                enumValues: {
                    sleep: "Sleep",
                    meditate: "Meditate"
                }
            }
        },
        emotions: {
            dataType: "array",
            title: "Emotions",
            // validation: {
            //     required: true
            // },
            // of: {
            //     dataType: "reference",
            //     collectionPath: "emotions",
            //     schema: emotionSchema
            // }
            of: {
                dataType: "string",
                config: {
                    enumValues:
                    {
                        smile: "Smile",
                        happy: "Happy",
                        sad: "Sad",
                        love: "Love",
                        Grounded: "Grounded",
                        Overwhelmed: "Overwhelmed",
                        Anxious: "Anxious",
                        Calm: "Calm",
                        Joyful: "Joyful",
                        Stressed: "Stressed",
                        Depressed: "Depressed",
                        Angry: "Angry",
                        Caring: "Caring",
                        "In Pain": "In Pain",
                        Frustrated: "Frustrated",
                        Worried: "Worried",

                    }
                }
            }




        },
        category_id: {
            title: "Category",
            dataType: "reference",
            description: "reference to category",
            collectionPath: "categories",
            previewProperties: ["title"]

        },
        cover: {
            title: "Cover",
            dataType: "string",
            config: {
                storageMeta: {
                    mediaType: "image",
                    storagePath: "images",
                    acceptedFiles: ["image/*"],
                    storeUrl: true
                }
            },
            validation: {
                required: true,
                requiredMessage: "Course image is required"
            }
        },
        updated_at: {
            dataType: "timestamp",
            title: "Updated_at",
            autoValue: "on_update"
        },
        publish: {
            dataType: "boolean",
            title: "Publish",
            validation: {
                required: true
            }
        },

    }
});

courseSchema.onSaveSuccess = () => {
    console.log("onSaveSuccess");
};

export default courseSchema;